var hash = require('../')

module.exports = function (onEnd) {
  return hash('sha256', 'base64', function (err, digest) {
    onEnd(err, digest && ('&' + digest + '.sha256'))
  })
}
